import PromoCodeReport from '@/views/report/PromoCodeReport.vue'
import WebsiteAnalyticsReport from '@/views/report/WebsiteAnalyticsReport.vue'

import * as Breadcrumbs from '../breadcrumbs/report'

export default [
	{
		path: '/report-promo-codes',
		name: 'report-promo-codes',
		component: PromoCodeReport,
		meta: {
			requiresAuth: true,
			title: 'Promo Code Usage Report',
			breadcrumb: [
				Breadcrumbs.PromoCodeReport,
			],
		},
	},
	{
		path: '/report-website-analytics',
		name: 'report-website-analytics',
		component: WebsiteAnalyticsReport,
		meta: {
			requiresAuth: true,
			title: 'Website Analytics Report',
			breadcrumb: [
				Breadcrumbs.WebsiteAnalyticsReport,
			],
		},
	},
]
